import { BusinessException } from "../model/BusinessException";

const env_core = {
    appPath: function (name?: w2p.environments.AppName): string {
        const origin = window?.location.origin ? window.location.origin : `${window.location.protocol}//${window.location.host}`;
        const path = window?.location?.pathname || "/";
        const stageChar = path.match(/(^(\/stage)?)/gi);
        const rootPath = origin + stageChar;
        if (stageChar != undefined && stageChar != null) {
            if (name) {
                return rootPath + "/" + this.apps[name];
            } else {
                return rootPath;
            }
        }
        throw new BusinessException("A00001");
    },
    apps: {
        text: "text-service",
        file: "file",
        cgp: "cgp-rest"
    }
}

export { env_core }